module.exports = __webpack_public_path__ + "files/2e913d4873aa3de601ee12a271fd86d7.svg";